var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"procedure-bar",attrs:{"id":"procedure-bar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }